import { render, staticRenderFns } from "./ModelPlaceConfig.vue?vue&type=template&id=444bd7e9&scoped=true"
import script from "./ModelPlaceConfig.vue?vue&type=script&lang=js"
export * from "./ModelPlaceConfig.vue?vue&type=script&lang=js"
import style0 from "./ModelPlaceConfig.vue?vue&type=style&index=0&id=444bd7e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444bd7e9",
  null
  
)

export default component.exports